import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { Badge, StatusChip } from '../ui';

type Props = {
  title: string;
  subtitle?: string;
  status?: string;
  organization?: string;
  marketplace?: string;
  brand?: string;
  healthScore?: number;
  actions?: ReactNode;
  className?: string;
};

export function WorkspaceHeader({
  title, subtitle, status, organization, marketplace, brand, healthScore, actions, className,
}: Props) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-4', className)}>
      <div>
        <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100">{title}</h1>
        {subtitle && <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>}
        <div className="mt-2 flex flex-wrap items-center gap-2">
          {status && <StatusChip status={status} />}
          {organization && <Badge variant="default">{organization}</Badge>}
          {marketplace && <Badge variant="info">{marketplace}</Badge>}
          {brand && <Badge variant="default">{brand}</Badge>}
          {healthScore != null && (
            <span className="text-xs text-slate-500">Health: {healthScore}%</span>
          )}
        </div>
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
